import ProvidersRoutes from "./providers";
import QueryProvidersRoutes from "./query_providers.js"

export default [...ProvidersRoutes, ...QueryProvidersRoutes];
